const config = {};

config.api = 'https://supervisor.leetlink.net/manager/api/';

config.weather = {access_id: 'L9mAaiyBjwFVgO5SGsoEr', secret_key: 'ivWv2cet1Stn1ULKhkp19cxK1SRtvBy0mXBOW3ag'};



export default config;
